import React from 'react'
import SegmentBy from './SegmentBy';
import { CHART_CONST_INFO } from '../../constants/common/chart/chartConst';

function UpcomingDueDateReport(props: { selectedReport: string, RenderWorkGroupDropDown: Function, RenderByWorkGroup: Function, segmentBy: string, setSegmentBy:Function, isDrillDownActive:boolean }) {
    const { selectedReport, RenderWorkGroupDropDown, RenderByWorkGroup, segmentBy, setSegmentBy, isDrillDownActive } = props;
    return (
        <div>
            <div className='filter-container'>
                <SegmentBy selectedReport={selectedReport} segmentBy={segmentBy} setSegmentBy={ setSegmentBy } isDrillDownActive={ isDrillDownActive}/>
                <div className='--select-report-container'>
                    {<RenderWorkGroupDropDown />}
                </div>
            </div>
            <>
                <RenderByWorkGroup title={segmentBy === 'status' ? CHART_CONST_INFO.STATUS : CHART_CONST_INFO.DUEDATE} />
            </>
        </div>
    )
}

export default UpcomingDueDateReport